import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Logo from './Logo';

const links = [
  { label: 'Services', href: '#services', id: 'services' },
  { label: 'Who We Serve', href: '#audiences', id: 'audiences' },
  { label: 'The Firm', href: '#about', id: 'about' },
  { label: 'Our Team', href: '#team', id: 'team' },
  { label: 'Contact', href: '#contact', id: 'contact' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-cream/90 backdrop-blur-md border-b border-navy/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo onDark={!scrolled} />
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.id}`}
              className={`text-xs tracking-[0.2em] uppercase transition-colors duration-300 hover:text-gold ${
                scrolled ? 'text-navy' : 'text-cream/80'
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+19199675733"
            data-testid="nav-phone-cta"
            className={`text-xs tracking-[0.2em] uppercase border px-5 py-2.5 transition-colors duration-300 ${
              scrolled
                ? 'border-navy/30 text-navy hover:bg-navy hover:text-cream'
                : 'border-cream/30 text-cream hover:bg-gold hover:border-gold hover:text-navy'
            }`}
          >
            919-967-5733
          </a>
        </nav>
        <a
          href="tel:+19199675733"
          data-testid="nav-phone-cta-mobile"
          className={`md:hidden text-xs tracking-[0.15em] uppercase border px-4 py-2 ${
            scrolled ? 'border-navy/30 text-navy' : 'border-cream/30 text-cream'
          }`}
        >
          Call
        </a>
      </div>
    </motion.header>
  );
}
